import { request } from '../request';

const ambassadors = {
  // 获取大使列表
  getAmbassadorsList: (data) => request('/api/ambassadors', 'get', data),
  // 获取大使详情
  getAmbassadorsDetail: (data) => request(`/api/ambassadors/${data.name}`, 'get', data),
  /** 红人墙列表 */
  getWallList: (data) =>
    request('/api/subject/product_influencer_wall/lists', 'get', data, {
      errorMsg: false,
    }),
};
export default ambassadors;
